import styled from "styled-components";

export const ShippingDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
